import { Dispatch, SetStateAction } from 'react';
import { Pagination, PaginationItem, PaginationLink } from 'reactstrap';
import Arrow from '@assets/images/dashboard/pageArrow.svg';
import Arrow2 from '@assets/images/dashboard/pageArrow2.svg';
import theme from '@theme/index';
import styled from 'styled-components';

const PaginationItemS = styled(PaginationItem)`
  border: none;
  display: flex;
  align-items: center;
  margin: 0 0.125rem;
  :nth-child(${(props) => (props.page % 10 !== 0 ? (props.page % 10) + 2 : 12)}) {
    .page-link {
      color: #fff !important;
      background-color: ${({ theme }) => theme.primary};
      border-radius: 0.25rem;
      :focus {
        box-shadow: none;
      }
    }
  }

  .page-link {
    width: 2rem;
    height: 2rem;
    border: none;
    font-size: 0.875rem;
    padding: 0.25rem 0.5rem;
    background-color: #cfd8e2;
    color: #fff !important;
    border-radius: 0.25rem;
    display: flex;
    align-items: center;
    justify-content: center;
    :focus {
      box-shadow: none;
    }
    :hover {
      background-color: #b2f1f6;
    }
  }
`;

const PageContainer = styled.div`
  .page-link {
    border: none !important;
    font-size: 0.875rem;
    width: 2rem;
    height: 2rem;
    color: #91979e !important;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0.25rem;
    :hover {
      background-color: #ffffff;
      border: none;
    }
  }
`;

interface Props {
  setCurrentPage: Dispatch<SetStateAction<number>>;
  totalLength: number;
  postsPerPage: number;
  currentPage: number;
  pagecount?: number;
  padding?: number;
}

const PaginationComponent = ({
  setCurrentPage,
  totalLength,
  postsPerPage,
  currentPage,
  pagecount,
  padding,
}: Props) => {
  // pagination
  const calculatedPage = pagecount ? totalLength : Math.ceil(totalLength / postsPerPage);
  const page = Math.max(1, calculatedPage);
  let pageItem = [];
  //출력되는 페이지
  let printPage = [];
  let arrayNum =
    currentPage % 10 === 0 ? Math.floor(currentPage / 10) - 1 : Math.floor(currentPage / 10);

  for (let i = 0; i < page; i++) {
    pageItem.push(
      <PaginationItemS
        page={currentPage}
        key={i + 1}
        onClick={({ target }: { target: any }) => {
          setCurrentPage(+target.innerText);
        }}>
        <PaginationLink>{i + 1}</PaginationLink>
      </PaginationItemS>,
    );
  }
  if (pageItem.length > 10) {
    // printPage = pageItem.division(10);
    for (let i = 0; i < pageItem.length; i += 10) printPage.push(pageItem.slice(i, i + 10));
  }

  return (
    <div
      style={{
        justifyContent: 'center',
        padding: padding === 0 ? '1rem 0 0' : '2rem 0 7rem',
        display: 'flex',
      }}>
      <Pagination className="pagination-primary pagination">
        <PaginationItem
          onClick={() => {
            currentPage - 10 > 0 ? setCurrentPage(currentPage - 10) : setCurrentPage(1);
          }}>
          <PageContainer style={{ color: '#91979e !important' }}>
            <PaginationLink>
              <span aria-hidden="true">
                <img style={{ transform: 'rotate(180deg)' }} src={Arrow2} alt="«" />
              </span>
              <span className="sr-only">{''}</span>
            </PaginationLink>
          </PageContainer>
        </PaginationItem>
        <PaginationItem
          onClick={() => {
            currentPage - 1 === 0 ? setCurrentPage(1) : setCurrentPage(currentPage - 1);
          }}>
          <PageContainer>
            <PaginationLink>
              <span aria-hidden="true">
                {' '}
                <img style={{ transform: 'rotate(180deg)' }} src={Arrow} alt="&lsaquo;" />
              </span>
              <span className="sr-only">{''}</span>
            </PaginationLink>
          </PageContainer>
        </PaginationItem>
        {printPage?.length > 0 ? printPage[arrayNum] : pageItem}
        <PaginationItem
          onClick={() => {
            +currentPage === +pageItem?.length
              ? setCurrentPage(+pageItem?.length)
              : setCurrentPage(currentPage + 1);
          }}>
          <PageContainer>
            <PaginationLink>
              <span aria-hidden="true">
                {' '}
                <img src={Arrow} alt="&rsaquo;" />
              </span>
              <span className="sr-only">{}</span>
            </PaginationLink>
          </PageContainer>
        </PaginationItem>
        <PaginationItem
          onClick={() => {
            currentPage + 10 < pageItem?.length
              ? setCurrentPage(currentPage + 10)
              : setCurrentPage(pageItem?.length);
          }}>
          <PageContainer>
            <PaginationLink>
              <span aria-hidden="true">
                <img src={Arrow2} alt="»" />
              </span>
              <span className="sr-only">{}</span>
            </PaginationLink>
          </PageContainer>
        </PaginationItem>
      </Pagination>
    </div>
  );
};
export default PaginationComponent;
